module.exports = __webpack_public_path__ + "img/mgh-nagoya@2x.757dc5a9.jpg";